import React, { useState, useEffect, useCallback } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Label } from '@/components/ui/label';
import { Loader2 } from 'lucide-react';
import { userService } from '../../_services/user.service';

function ReportPopup({ text, closePopup }) {
    const [loading, setLoading] = useState(false);
    const [btnLoading, setBtnLoading] = useState(false);
    const [error, setError] = useState('');
    const [monthList, setMonthList] = useState([]);
    const [selectedMonth, setSelectedMonth] = useState('');
    
    const [userdata] = useState(() => {
        try {
            const user = JSON.parse(localStorage.getItem('user'));
            if (!user) {
                userService.logout();
                return null;
            }
            return user;
        } catch {
            userService.logout();
            return null;
        }
    });

    const fetchCommissionData = useCallback(async () => {
        if (!userdata) return;
        
        setLoading(true);
        setError('');
        
        try {
            const response = await fetch('/api/ws/wh_commission_type', {
                method: 'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    'X-Browser-Url': window.location.href 
                },
                body: JSON.stringify({
                    whname: userdata.wholesaler,
                    wholesaler_Id: userdata.wholesaler_Id,
                    mname: ''
                })
            });
            
            const data = await response.json();
            
            if (data?.length > 0 && data[0].monthList) {
                setMonthList(data[0].monthList);
                if (data[0].monthList.length > 0) {
                    setSelectedMonth(data[0].monthList[0].monthYearname);
                }
            } else {
                //setError('Data not found');
            }
        } catch (err) {

            //setError('Failed to load data');
        } finally {
            setLoading(false);
        }
    }, [userdata]);

    useEffect(() => {
        fetchCommissionData();
    }, [fetchCommissionData]);

    const handleDownload = useCallback((e) => {
        e.preventDefault();
        
        if (!selectedMonth || !userdata) return;
        
        try {
            const originLocation = window.location.protocol + '//' + window.location.host;
            const whId = userdata.wholesaler_Id;
            const uniqueObjectId = userdata.unique_ObjectId;
            const paramsName = userdata.paramsname;
            
            const endpoint = whId === 61 
                ? '/report/payout_report_jd' 
                : '/report/payout_report_nonjd';
            
            const url = `${originLocation}${endpoint}?&name=${paramsName}&wh_id=${whId}&csvfor=ds&m=${selectedMonth}&processor=0&ObjectId=${uniqueObjectId}`;
            
            window.open(url, '_blank');
        } catch (err) {

        }
    }, [selectedMonth, userdata]);

    const handleOpenChange = useCallback((open) => {
        if (!open) {
            closePopup();
        }
    }, [closePopup]);

    return (
        <Dialog open={true} onOpenChange={handleOpenChange}>
            <DialogContent className="sm:max-w-md">
                <DialogHeader>
                    <DialogTitle>{text}</DialogTitle>
                </DialogHeader>
                
                <div className="flex flex-col gap-4">
                    {loading ? (
                        <div className="flex items-center justify-center p-8 min-h-[120px]">
                            <Loader2 className="h-8 w-8 animate-spin text-primary" />
                        </div>
                    ) : monthList.length > 0 ? (
                        <form onSubmit={handleDownload} className="flex flex-col gap-4">
                            <div className="flex flex-col gap-2">
                                <Label htmlFor="month-select">Select Month, Year</Label>
                                <Select value={selectedMonth} onValueChange={setSelectedMonth}>
                                    <SelectTrigger id="month-select">
                                        <SelectValue placeholder="Select month" />
                                    </SelectTrigger>
                                    <SelectContent>
                                        {monthList.map((item, index) => (
                                            <SelectItem key={index} value={item.monthYearname}>
                                                {item.monthYearname.replace(',', ', ')}
                                            </SelectItem>
                                        ))}
                                    </SelectContent>
                                </Select>
                            </div>
                        </form>
                    ) : (
                        <div className="flex items-center justify-center p-8 text-muted-foreground text-center text-[15px]">
                            {error || 'No data available'}
                        </div>
                    )}
                            </div>
                            
                {monthList.length > 0 && (
                    <DialogFooter>
                                <Button
                                    type="submit"
                                    disabled={btnLoading || !selectedMonth}
                            onClick={handleDownload}
                                >
                                    {btnLoading ? (
                                        <>
                                            <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                                            Downloading...
                                        </>
                                    ) : (
                                        'Download'
                                    )}
                                </Button>
                                <Button
                                    type="button"
                                    variant="secondary"
                                    onClick={closePopup}
                                >
                                    Cancel
                                </Button>
                    </DialogFooter>
                    )}
            </DialogContent>
        </Dialog>
    );
}

export default ReportPopup;
